<div class="header">
  <h3>รายงานภาษีขาย</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>

  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="company"
          [options]="company"
          [(ngModel)]="selectedCompany"
          (onChange)="filterBranchList()"
          [autoDisplayFirst]="false"
          placeholder="บริษัท"
          [style]="{'z-index': 3}"
        >
        </p-dropdown>
        <label for="company">บริษัท</label>
      </div>

      <div class="dropdown-label-group m-t-10 d-none">
        <p-dropdown
          class="dv-dropdown"
          selectId="companyBusiness"
          [options]="homeproGroup"
          [(ngModel)]="selectedHomeproGroup"
          [autoDisplayFirst]="false"
          placeholder="ประเภทธุรกิจ"
        >
        </p-dropdown>
        <label for="companyBusiness">ประเภทธุรกิจ</label>
      </div>

      <div class="dropdown m-t-10" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
                 ngbDropdownToggle placeholder="วันที่" readonly>
          <label for="calendarDropdown">วันที่</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">ตั้งแต่</div>
            <div class="col" style="padding-left: 30px">ถึง</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="companyBranch"
          [options]="branchList"
          [(ngModel)]="selectedBranch"
          [autoDisplayFirst]="false"
          placeholder="สาขา"
          [style]="{'z-index': 3}"
        >
        </p-dropdown>
        <label for="companyBranch">สาขา</label>
      </div>

      <div class="dropdown-label-group m-t-10">
        <p-dropdown
          class="dv-dropdown"
          selectId="documentType"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [autoDisplayFirst]="false"
          placeholder="ประเภทเอกสาร"
        >
        </p-dropdown>
        <label for="documentType">ประเภทเอกสาร</label>
      </div>


      <div class="d-none">
        <p-autoComplete [(ngModel)]="branch" [disabled]="allBranch" field="full_name" [multiple]="true"
                        [suggestions]="branchSuggest" [size]="30" (completeMethod)="searchBranch($event)"
                        (onClear)="clearBranch()" class="dv-autocomplete" placeholder="สาขา">
        </p-autoComplete>
      </div>

      <div class="m-t-10 d-none">
        <p-autoComplete [(ngModel)]="documentType" [disabled]="allDocType" field="type" [multiple]="true"
                        [suggestions]="typeSuggest" [size]="30" (completeMethod)="searchDocumentType($event)"
                        (onClear)="clearDocType()" class="dv-autocomplete" placeholder="ประเภทเอกสาร">
        </p-autoComplete>
      </div>
    </div>
    <div class="col-md-4">
      <div class="row align-items-center" style="height: 50%">
        <div class="col-md-auto">
          <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="notApprove"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="notApprove">-->
          <span>เฉพาะรายการที่ยังไม่ได้ตรวจสอบ</span>
        </div>
        <div class="col d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allBranch" binary="true" (onChange)="selectAllBranch()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allBranch" (change)="selectAllBranch()">-->
          <span>ทุกสาขา</span>
        </div>
      </div>
      <div class="row align-items-center" style="height: 50%;">
        <div class="col-md-auto d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allDocType" binary="true" (onChange)="selectDocType()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allDocType" (change)="selectDocType()">-->
          <span>ทุกประเภทเอกสาร</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="errorMsg">
    <div class="col text-center text-red">
      {{ errorMsg }}
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="no_data === false"
  >
    <div class="col-auto">
      <button type="button" class="btn btn-dv btn-wide" (click)="exportRange()">
        ดาวน์โหลดทั้งหมด
      </button>
    </div>
  </app-custom-pagination>

  <!--<div class="row m-t-20" *ngIf="loading === true">-->
    <!--<div class="col-12 text-center">-->
      <!--<i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>-->
    <!--</div>-->
  <!--</div>-->

  <div class="row m-t-20" *ngIf="no_data === true && loading === false">
    <div class="col-12 text-center">
      <h5>ไม่พบข้อมูล</h5>
    </div>
  </div>

  <div class="m-t-20">
    <p-table #tt class="text-center" tableStyleClass="table" *ngIf="no_data === false" [loading]="loading"
             [columns]="tableCol" [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>ลำดับ</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
            <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
          </th>
          <th>ถูกแล้ว</th>
          <th>ดาวน์โหลด</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.header_issue_display}}</td>
          <td class="d-none">{{data.group__name}}</td>
          <td>{{data.corporate_branch__name}}</td>
          <td>{{data.rd_document_type_display || data.document_type__name}}</td>
          <td class="d-none">{{data.document_type__type}}</td>
          <td>{{data.start_end_document}}</td>
          <td>{{data.total_documents}}</td>
          <!--<td>{{data.last_day_document_display}}</td>-->
          <td>
            <span>
              {{data.total_missing_documents.toLocaleString()}}
            </span>
            <span>
              <button *ngIf="data.total_missing_documents !== 0" style="width: 100%" class="btn btn-dv btn-clean btn-compact" (click)="downloadMissingDocs(data, index)">
                <i *ngIf="data.loading_missing_docs_excel === true" class="fa fa-spinner fa-spin m-r-5"></i>Excel
              </button>
            </span>
          </td>
          <td>
            {{data.total_non_vat | number : '1.2-2'}}
          </td>
          <td>
            {{data.total_basis_amount | number : '1.2-2'}}
          </td>
          <td>
            {{data.total_vat | number : '1.2-2'}}
          </td>
          <!--<td>-->
          <!--{{(data.total_non_vat + data.total_basis_amount + data.total_vat).toLocaleString()}}-->
          <!--</td>-->
          <td class="text-center">
            <i *ngIf="!canUserApproveDoc() && data.approved === true"
               class="fa fa-check m-r-5">
            </i>
            <!--<input *ngIf="canUserApproveDoc()"-->
                   <!--type="checkbox"-->
                   <!--[(ngModel)]="data.approved"-->
                   <!--(change)="confirmDocument($event, content, index, data)">-->
            <p-checkbox class="dv-checkbox" *ngIf="canUserApproveDoc()" [(ngModel)]="data.approved" binary="true"
                        (click)="confirmDocument($event, content, index)" [inputId]="'chkbox' + index"></p-checkbox>
          </td>
          <td>
            <button class="btn btn-dv btn-clean btn-compact" style="width: 100%" (click)="getExportDocs(data, index)">
              <i *ngIf="data.loading_all_docs_excel === true" class="fa fa-spinner fa-spin m-r-5"></i>Excel
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <!--<h4 class="modal-title" id="modal-basic-title">Alert</h4>-->
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h5>กด ตกลง เพื่อยืนยันการทำรายการ</h5>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="revertBack()">ยกเลิก
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" [disabled]="cofirm_loading" (click)="confirm()">
        <i *ngIf="cofirm_loading" class="fa fa-spinner fa-spin m-r-5"></i>
        ตกลง
      </button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.component.html